import { Link, useLocation } from 'react-router-dom';
import { useNotifications } from '../../notifications/NotificationContext';
import { roomTitle } from '../Together/roomAppearance';
import { RoomCover, activeClock, featuredRoom, nextStep, useCountdown } from '../Together/roomUi';
import './LiveBanner.css';

// A strip across every page whenever a room needs you: what's happening, the clock, and one button.
const LiveBanner = () => {
  const { liveRooms } = useNotifications();
  const { pathname, search } = useLocation();
  const openRoom = pathname === '/together' ? new URLSearchParams(search).get('room') : null;
  const rooms = liveRooms.filter(room => room.sessionId !== openRoom);
  const room = featuredRoom(rooms);
  const clock = activeClock(room);
  const countdown = useCountdown(clock?.deadlineAt, room?.serverTime, clock?.minutes);
  if (!room) return null;
  const step = nextStep(room);
  const timed = Boolean(clock) && countdown;
  return <div className={`live-banner live-banner--${step.tone}`} role="status">
    <div className="live-banner__inner">
      <RoomCover room={room} className="live-banner__cover" />
      <div className="live-banner__text"><strong>{roomTitle(room)}</strong><span>{step.text}{timed ? (countdown!.expired ? '' : ` · ${countdown!.label} left`) : ''}{rooms.length > 1 ? ` · +${rooms.length - 1} more` : ''}</span></div>
      <Link className="live-banner__cta" to={`/together?room=${room.sessionId}`}>{step.cta}</Link>
    </div>
    {timed && !countdown!.expired && <span className="live-banner__progress" style={{ width: `${countdown!.fraction * 100}%` }} />}
  </div>;
};

export default LiveBanner;
